// Adicione o conteúdo do arquivo js

import Swiper from 'swiper';

export default function setBannerLinha() {
    const bannerLinha = document.querySelector('.banner-linha.swiper');

    const newFullbanner = new Swiper(bannerLinha, {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        watchOverflow: true,
        speed: 1000,
        autoplay: true,
        // initialSlide: 3,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 3.3
            }
        }
    });
}